import { Switch } from "antd";
import React, { useEffect, useState } from "react";
import { CartesianGrid, ResponsiveContainer } from "recharts";

export const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

const DailyTrafficContent = ({ polygon, isVisible }) => {
	const [heatMapDataSource, setHeatMapDataSource] = useState(polygon.filterData.popular_times);

	useEffect(() => {
		if (polygon.filterData.popular_times) {
			setHeatMapDataSource(polygon.filterData.popular_times);
		}
	}, [polygon]);
	if (!isVisible || !polygon?.filterData?.popular_times) return null;

	const heatmapData = heatMapDataSource?.reduce((acc, { name, data }) => {
		data.forEach((value, hour) => {
			acc.push({ day: name?.replace(/\*/g, ""), hour, value });
		});
		return acc;
	}, []);

	const getColor = value => {
		if (value <= 40) {
			// White (255, 255, 255) → Dark Yellow (255, 200, 0)
			const green = Math.round(255 - (value / 40) * 55); // 255 → 200
			const blue = Math.round(255 - (value / 40) * 255); // 255 → 0
			return `rgb(255, ${green}, ${blue})`;
		} else if (value <= 60) {
			// Light Red (255, 150, 150) → Dark Red (139, 0, 0)
			const t = (value - 40) / 20; // 0 → 1
			const red = Math.round(255 - t * (255 - 139)); // 255 → 139
			const green = Math.round(150 - t * 150); // 150 → 0
			const blue = Math.round(150 - t * 150); // 150 → 0
			return `rgb(${red}, ${green}, ${blue})`;
		} else {
			// Light Brown (205, 133, 63) → Dark Brown (101, 67, 33)
			const t = (value - 60) / 40; // 0 → 1
			const red = Math.round(205 - t * (205 - 101)); // 205 → 101
			const green = Math.round(133 - t * (133 - 67)); // 133 → 67
			const blue = Math.round(63 - t * (63 - 33)); // 63 → 33
			return `rgb(${red}, ${green}, ${blue})`;
		}
	};

	const formatHour = hour => {
		const period = hour >= 12 ? "PM" : "AM";
		const formattedHour = hour % 12 || 12; // Convert 0 to 12 for midnight
		return `${formattedHour}${period}`;
	};

	return (
		<div style={{ padding: "20px", display: "flex", flexDirection: "column", alignItems: "center" }}>
			{polygon.filterData.popular_times_past_years && (
				<Switch
					disabled
					unCheckedChildren={"Footfall over the past year"}
					checkedChildren={"Footfall over the past year"}
					onChange={checked => {
						if (checked) {
							setHeatMapDataSource(polygon.filterData.popular_times_past_years);
						} else {
							setHeatMapDataSource(polygon.filterData.popular_times);
						}
					}}
				>
					Toogle
				</Switch>
			)}
			<ResponsiveContainer width="90%" height={600}>
				<svg width="1000" height="500" viewBox="-150 -50 1200 620">
					<CartesianGrid strokeDasharray="3 3" />
					{/* Render Heatmap Rectangles */}
					{heatmapData.map((entry, index) => (
						<rect
							key={index}
							x={(entry.hour / 24) * 900} // Scale x-axis for 24 hours
							y={(days.indexOf(entry.day) / 7) * 500} // Scale y-axis for 7 days
							width={900 / 24} // Width of each hour rectangle
							height={500 / 7} // Height of each day rectangle
							fill={getColor(entry.value)}
							stroke="#ccc"
							strokeWidth="0.5"
						/>
					))}
					{/* Render Day Labels */}
					{days.map((day, i) => (
						<text
							key={day}
							x="-50" // Adjusted closer to the y-axis label
							y={(i + 0.5) * (500 / 7)} // Center text vertically
							fontSize="14"
							textAnchor="end"
							fill="#333"
							fontWeight="bold"
						>
							{day}
						</text>
					))}
					{/* Render Hour Labels */}
					{Array.from({ length: 24 }).map((_, hour) => (
						<text
							key={hour}
							x={(hour / 24) * 900 + 900 / 48} // Center text horizontally
							y="520" // Position below the heatmap
							fontSize="14"
							textAnchor="middle"
							fill="#333"
							fontWeight="bold"
						>
							{formatHour(hour)}
						</text>
					))}
					{/* Add X-axis Label */}
					<text x="450" y="550" fontSize="16" textAnchor="middle" fill="#000" fontWeight="bold">
						Time of Day (hours)
					</text>
					{/* Add Y-axis Label */}
					<text
						x="-310" // Position closer to day labels
						y="430" // Center vertically
						fontSize="16"
						textAnchor="middle"
						transform="rotate(-90, -350, 250)"
						fill="#000"
						fontWeight="bold"
					>
						Day of Week
					</text>
					{/* Add Legend */}
					<g>
						{[
							{ label: "", value: 100 },
							{ label: "Heavy Traffic", value: 87 },
							{ label: "", value: 81 },

							{ label: "", value: 60 },
							{ label: "Moderate Traffic", value: 55 },

							{ label: "", value: 50 },
							{ label: "", value: 39 },
							{ label: "Light Traffic", value: 27 },
							{ label: "", value: 20 },

							{ label: "", value: 9 },
							{ label: "", value: 4 },

							{ label: "No Traffic", value: 0 }
						].map((item, i) => (
							<g key={i}>
								<rect x="920" y={50 + i * 40} width="20" height="40" fill={getColor(item.value)} />
								<text x="950" y={75 + i * 40} fontSize="12" fill="#333" fontWeight="bold">
									{item.label}
								</text>
							</g>
						))}
						<text x="920" y="30" fontSize="14" textAnchor="start" fill="#000" fontWeight="bold">
							Traffic Levels
						</text>
					</g>
				</svg>
			</ResponsiveContainer>
		</div>
	);
};

export default DailyTrafficContent;
